var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavAcademics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 8.1665V16.6665M10 16.6665L9.5154 15.9398C9.08477 15.2938 8.86881 14.9699 8.58317 14.7351C8.32927 14.5264 8.03588 14.37 7.7214 14.2745C7.36618 14.1667 6.97495 14.1667 6.19227 14.1667H3.83164C3.36584 14.1667 3.133 14.1667 2.95492 14.0759C2.79811 13.996 2.67072 13.8682 2.59083 13.7114C2.5 13.5332 2.5 13.3001 2.5 12.8334V5.50008C2.5 5.03337 2.5 4.79984 2.59083 4.62158C2.67072 4.46478 2.79811 4.33739 2.95492 4.25749C3.13318 4.16667 3.3663 4.16667 3.83301 4.16667H5.99967C7.39981 4.16667 8.10003 4.16667 8.63481 4.43915C9.10522 4.67883 9.48769 5.06141 9.72738 5.53182C9.99986 6.0666 10 6.76637 10 8.1665C10 6.76637 10 6.0666 10.2725 5.53182C10.5122 5.06141 10.8943 4.67883 11.3647 4.43915C11.8995 4.16667 12.5997 4.16667 13.9998 4.16667H16.1665C16.6332 4.16667 16.8667 4.16667 17.045 4.25749C17.2018 4.33739 17.329 4.46478 17.4089 4.62158C17.4997 4.79984 17.5 5.03337 17.5 5.50008V12.8334C17.5 13.3001 17.4997 13.5332 17.4089 13.7114C17.329 13.8682 17.2021 13.996 17.0453 14.0759C16.8672 14.1667 16.6342 14.1667 16.1684 14.1667H13.8078C13.0251 14.1667 12.6331 14.1667 12.2778 14.2745C11.9634 14.37 11.6714 14.5264 11.4175 14.7351C11.1307 14.9708 10.9134 15.2964 10.4792 15.9477L10 16.6665Z",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavAcademics);
export default __webpack_public_path__ + "static/media/nav-academics.ca09a195d1c968fb7f1932c7db2944a7.svg";
export { ForwardRef as ReactComponent };